import { useNavigate } from "react-router-dom";
import bgImg5 from "../../assets/images/communication/COMMUNICATION.webp";
import Hero from "../../Components/HeroIndustries/HeroIndustries";
import { ServiceCardView } from "../../Components/ServiceCardView";
const Index = () => {
  const navigate = useNavigate();

  return (
    <>
      <Hero
        pageName="SERVICES / DATA & AI STRATEGY CONSULTING"
        pageIntro="Design scalable data architectures and AI strategies for enterprise transformation."
        pageIntroPara={""}
        alt="img"
        image={bgImg5}
      />

      <ServiceCardView
        list={[
          {
            id: "cloud-architecture",
            title: "Cloud & Data Architecture Consulting",
            desc: "Design scalable, multi-cloud architectures to enhance data processing and support enterprise analytics, achieving up to 5X performance gains.",
            technologies: "Terraform, AWS, Azure, Snowflake, Redshift",
            features: [
              "Multi-cloud architecture design",
              "Scalable data platforms",
              "Cost optimization",
              "Real-time pipeline integration",
            ],
            impact: "5X faster processing, 40% cost reduction",
            caseStudy: {
              client: "Global Financial Services Firm",
              challenge:
                "Fragmented cloud systems slowed data processing and increased operational costs.",
              solution:
                "NucleusTeq designed a multi-cloud architecture using Terraform and AWS, integrating Snowflake for scalable analytics.",
              outcome:
                "Improved data processing speed by 4X and reduced infrastructure costs by 35%.",
            },
            imagePrompt: {
              description:
                "A digital dashboard displaying a multi-cloud architecture with AWS and Azure icons, overlaid with data flow diagrams. Use blue and white (#007BFF, #FFFFFF) for a clean, professional look.",
              style: "Corporate, data-driven, digital art, 800x400px",
              altText:
                "Financial services dashboard with multi-cloud architecture",
            },
            buttunData: {
              buttonText: "Build Your Data & AI Roadmap",
              buttonAction: () => {
                navigate("/contact");
              },
            },
          },
          {
            id: "data-lake-planning",
            title: "Data Lake & Warehouse Planning",
            desc: "Plan and implement data lakes and warehouses to centralize and optimize data storage for advanced analytics and reporting.",
            technologies: "Snowflake, Redshift",
            features: [
              "Scalable data lakes",
              "High-performance warehouses",
              "Data unification",
              "Cost-efficient storage",
            ],
            impact: "50% faster data access, 30% reduced storage costs",
            caseStudy: {
              client: "E-commerce Retailer",
              challenge:
                "Disparate data sources hindered unified analytics for customer insights.",
              solution:
                "NucleusTeq implemented a Snowflake-based data lake, centralizing customer and sales data for advanced analytics.",
              outcome:
                "Reduced data access time by 45% and cut storage costs by 28%.",
            },
            imagePrompt: {
              description:
                "An e-commerce analytics dashboard showing unified customer data from a Snowflake data lake, with charts and graphs. Use blue gradient (#E6F0FA to #007BFF) for a modern design.",
              style: "Retail, data-centric, digital art, 800x400px",
              altText: "E-commerce dashboard with unified data lake analytics",
            },
            buttunData: {
              buttonText: "Build Your Data & AI Roadmap",
              buttonAction: () => {
                navigate("/contact");
              },
            },
          },
          {
            id: "pipeline-consulting",
            title: "Real-Time Pipeline Consulting",
            desc: "Create real-time data pipelines to enable dynamic analytics and decision-making with low-latency processing.",
            technologies: "Kafka, Flink",
            features: [
              "Real-time data processing",
              "Scalable pipelines",
              "Low-latency integration",
              "Dynamic workload support",
            ],
            impact: "60% faster data processing, 25% improved efficiency",
            caseStudy: {
              client: "Logistics Provider",
              challenge:
                "Delayed data processing impacted real-time shipment tracking and optimization.",
              solution:
                "NucleusTeq designed Kafka-based real-time pipelines, enabling dynamic tracking and analytics for shipments.",
              outcome:
                "Cut data processing time by 55% and improved logistics efficiency by 20%.",
            },
            imagePrompt: {
              description:
                "A logistics control room with a dashboard showing real-time shipment tracking and pipeline status. Use blue and white (#007BFF, #FFFFFF) for a high-tech aesthetic.",
              style: "Logistics, futuristic, digital art, 800x400px",
              altText: "Logistics dashboard with real-time data pipelines",
            },
            buttunData: {
              buttonText: "Build Your Data & AI Roadmap",
              buttonAction: () => {
                navigate("/contact");
              },
            },
          },
          {
            id: "cost-optimization",
            title: "Cost Optimization Assessments",
            desc: "Conduct cost audits to optimize cloud and data resources, maximizing ROI and operational efficiency.",
            technologies: "AWS Cost Explorer, Azure Cost Management",
            features: [
              "Cost auditing",
              "Resource optimization",
              "Budget alignment",
              "ROI maximization",
            ],
            impact: "40% cost savings, 20% higher ROI",
            caseStudy: {
              client: "Healthcare Organization",
              challenge:
                "High cloud costs strained budgets without clear visibility into resource usage.",
              solution:
                "NucleusTeq performed a cost optimization assessment using AWS Cost Explorer, identifying inefficiencies and optimizing resource allocation.",
              outcome: "Reduced cloud costs by 38% and increased ROI by 15%.",
            },
            imagePrompt: {
              description:
                "A healthcare cost management dashboard showing cloud cost breakdowns and optimization metrics. Use blue gradient (#E6F0FA to #007BFF) for a professional look.",
              style: "Healthcare, analytical, digital art, 800x400px",
              altText: "Healthcare dashboard with cloud cost optimization",
            },
            buttunData: {
              buttonText: "Build Your Data & AI Roadmap",
              buttonAction: () => {
                navigate("/contact");
              },
            },
          },
          {
            id: "gen-ai-consulting",
            title: "Gen AI & ML Consulting",
            desc: "Develop AI and ML strategies to reduce time-to-value and drive innovation through high-impact use cases.",
            technologies: "TensorFlow, PyTorch, Design Thinking, AI Canvas",
            features: [
              "AI strategy roadmaps",
              "Use case identification",
              "PoC development",
              "Change management",
            ],
            impact: "50% reduced time-to-value, 30% faster AI adoption",
            caseStudy: {
              client: "Manufacturing Company",
              challenge:
                "Lack of AI expertise delayed adoption of predictive maintenance solutions.",
              solution:
                "NucleusTeq conducted Design Thinking workshops and built TensorFlow-based PoCs to develop an AI strategy for predictive maintenance.",
              outcome:
                "Accelerated AI adoption by 45% and reduced maintenance costs by 20%.",
            },
            imagePrompt: {
              description:
                "A manufacturing workshop with professionals designing an AI strategy, overlaid with digital predictive maintenance icons. Use blue and white (#007BFF, #FFFFFF) for a collaborative design.",
              style: "Industrial, collaborative, digital art, 800x400px",
              altText:
                "Manufacturing workshop designing AI strategy for predictive maintenance",
            },
            buttunData: {
              buttonText: "Build Your Data & AI Roadmap",
              buttonAction: () => {
                navigate("/contact");
              },
            },
          },
          {
            id: "ai-integration",
            title: "AI Integration Roadmaps",
            desc: "Design seamless AI integration strategies to ensure interoperability and scalability across enterprise systems.",
            technologies: "MuleSoft, Apache Camel",
            features: [
              "Seamless AI integration",
              "System interoperability",
              "Scalable architectures",
              "Business alignment",
            ],
            impact: "40% faster integration, 25% improved efficiency",
            caseStudy: {
              client: "Retail Chain",
              challenge:
                "Disparate systems hindered AI integration for personalized customer experiences.",
              solution:
                "NucleusTeq created an AI integration roadmap using MuleSoft, connecting CRM and AI systems for personalized recommendations.",
              outcome:
                "Reduced integration time by 35% and improved customer engagement by 18%.",
            },
            imagePrompt: {
              description:
                "A retail CRM dashboard showing AI-driven personalized recommendations, with MuleSoft integration icons. Use blue gradient (#E6F0FA to #007BFF) for a modern design.",
              style: "Retail, data-driven, digital art, 800x400px",
              altText: "Retail CRM dashboard with AI integration",
            },
            buttunData: {
              buttonText: "Build Your Data & AI Roadmap",
              buttonAction: () => {
                navigate("/contact");
              },
            },
          },
          {
            id: "ai-adoption",
            title: "AI Adoption Consulting",
            desc: "Facilitate enterprise-wide AI adoption through change management and stakeholder engagement.",
            technologies: "Change management frameworks",
            features: [
              "Stakeholder engagement",
              "Training programs",
              "Adoption roadmaps",
              "Cultural alignment",
            ],
            impact: "60% faster adoption, 20% higher employee engagement",
            caseStudy: {
              client: "Telecom Operator",
              challenge:
                "Resistance to AI adoption slowed implementation of network optimization solutions.",
              solution:
                "NucleusTeq provided change management consulting, delivering training and stakeholder workshops to drive AI adoption.",
              outcome:
                "Increased adoption rate by 55% and improved employee engagement by 22%.",
            },
            imagePrompt: {
              description:
                "A telecom training session with employees learning AI tools, overlaid with digital network optimization icons. Use blue and white (#007BFF, #FFFFFF) for a collaborative aesthetic.",
              style: "Telecom, collaborative, digital art, 800x400px",
              altText: "Telecom training session for AI adoption",
            },
            buttunData: {
              buttonText: "Build Your Data & AI Roadmap",
              buttonAction: () => {
                navigate("/contact");
              },
            },
          },
          {
            id: "business-consulting",
            title: "Business Consulting",
            desc: "Align data and AI initiatives with business goals to drive revenue growth and strategic outcomes.",
            technologies: "Miro, MURAL, Tableau, Power BI",
            features: [
              "Strategic alignment",
              "KPI-driven analytics",
              "Stakeholder workshops",
              "Revenue optimization",
            ],
            impact: "25% revenue growth, 30% improved decision-making",
            caseStudy: {
              client: "Global Consumer Goods Company",
              challenge:
                "Misaligned data strategies limited revenue growth from new markets.",
              solution:
                "NucleusTeq facilitated Miro-based workshops and built Tableau dashboards to align AI initiatives with market expansion goals.",
              outcome:
                "Boosted revenue by 20% and improved strategic decisions by 28%.",
            },
            imagePrompt: {
              description:
                "A consumer goods dashboard with market expansion analytics and KPI metrics, overlaid with Miro workshop icons. Use blue gradient (#E6F0FA to #007BFF) for a strategic design.",
              style: "Consumer goods, analytical, digital art, 800x400px",
              altText:
                "Consumer goods dashboard with AI-driven market analytics",
            },
            buttunData: {
              buttonText: "Build Your Data & AI Roadmap",
              buttonAction: () => {
                navigate("/contact");
              },
            },
          },
          {
            id: "roi-analysis",
            title: "ROI Analysis Services",
            desc: "Quantify the financial impact of data and AI initiatives to optimize investments and drive value.",
            technologies: "Financial modeling tools",
            features: [
              "Impact quantification",
              "Cost-benefit analysis",
              "Investment prioritization",
              "Strategic planning",
            ],
            impact: "30% higher ROI, 20% better resource allocation",
            caseStudy: {
              client: "Insurance Provider",
              challenge:
                "Unclear ROI from AI investments delayed further funding decisions.",
              solution:
                "NucleusTeq conducted ROI analysis using financial modeling tools, quantifying benefits of AI-driven claims processing.",
              outcome:
                "Increased ROI by 25% and optimized resource allocation by 18%.",
            },
            imagePrompt: {
              description:
                "An insurance financial dashboard showing ROI metrics and investment analysis for AI initiatives. Use blue and white (#007BFF, #FFFFFF) for a professional look.",
              style: "Insurance, financial, digital art, 800x400px",
              altText: "Insurance dashboard with AI ROI analysis",
            },
            buttunData: {
              buttonText: "Build Your Data & AI Roadmap",
              buttonAction: () => {
                navigate("/contact");
              },
            },
          },
          {
            id: "governance-consulting",
            title: "Governance Strategy Consulting",
            desc: "Design data governance frameworks to ensure compliance and data integrity across enterprise operations.",
            technologies: "Collibra, Informatica",
            features: [
              "Data governance frameworks",
              "Compliance roadmaps",
              "Lineage tracking",
              "Policy enforcement",
            ],
            impact: "99.9% compliance, 25% reduced risk",
            caseStudy: {
              client: "Pharmaceutical Company",
              challenge:
                "Lack of governance frameworks risked non-compliance with FDA regulations.",
              solution:
                "NucleusTeq designed a Collibra-based governance framework, implementing lineage tracking and compliance policies.",
              outcome:
                "Achieved 100% FDA compliance and reduced regulatory risks by 22%.",
            },
            imagePrompt: {
              description:
                "A pharmaceutical dashboard showing data lineage and compliance metrics, with Collibra icons. Use blue gradient (#E6F0FA to #007BFF) for a secure, compliant design.",
              style: "Pharmaceutical, compliant, digital art, 800x400px",
              altText:
                "Pharmaceutical dashboard with data governance framework",
            },
            buttunData: {
              buttonText: "Build Your Data & AI Roadmap",
              buttonAction: () => {
                navigate("/contact");
              },
            },
          },
        ]}
        buttunData={{
          buttonText: "Request a Strategy Session",
          buttonAction: () => {
            navigate("/contact");
          },
        }}
      />
    </>
  );
};

export default Index;
